(function ($, Promise) {

		// Setup the prototype inheritance
		extend(BaseGameLYVLC, ANSMap);

		// Constructor
		function ANSMap() {

			// Super constructor
			BaseGameLYVLC.call(this, "data/ans-map.json");
			this.screensaverDelay = 15;

			// Override initial screen language flip interval
			this.initalScreenIntervalDuration = 14250;

			this.instructionsSwiper = false;
			this.thumbsSwiper = false;
			this.mainSwiper = false;

			this.playlist = new AudioPlaylist();

			this.redirectTimeout = false;
		}

		// To be overriden in child games
		ANSMap.prototype.buildContent = function () {
			return new Promise($.proxy(function (resolve, reject) {

				// Create instructions slides
				this.instructionsSwiper = new Swiper('#instructions', {
					speed: 400,
					pagination: {
						el: '.swiper-pagination',
						type: 'bullets',
					},
				});

				// Handle instructions videos play/pause
				this.instructionsSwiper.on("slideChangeTransitionStart", $.proxy(function () {
					this.stopInstructionVideos();
				}, this));
				this.instructionsSwiper.on("touchStart", $.proxy(function () {
					this.stopInstructionVideos();
				}, this));
				this.instructionsSwiper.on("transitionEnd", $.proxy(function () {
					this.startInstructionVideo(this.instructionsSwiper.activeIndex);
				}, this));

				// Create  slides
				var $model = $("#ans-map-main-slider-slide-model").attr("id", "").remove();
				var $thumbModel = $("#ans-map-nav-slider-slide-model").attr("id", "").remove();
				$(this.data.tabs).each($.proxy(function (i, tab) {

					// Create main slide
					var $el = $model.clone();
					$el.find(".title .en").html(tab.title.en);
					$el.find(".title .fr").html(tab.title.fr);
					$el.find(".description .en").html(tab.description.en);
					$el.find(".description .fr").html(tab.description.fr);
					if (tab.map && tab.map.zones) {
						$el.find(".map-overlays").append("<img class='zones' src='" + tab.map.zones + "' />")
					}
					if (tab.map && tab.map.strokes) {
						$el.find(".map-overlays").append("<img class='strokes' src='" + tab.map.strokes + "' />")
					}
					if (tab.map && tab.map.pins) {
						for (var j = 0; j < tab.map.pins.length; j++) {
							$el.find(".map-overlays").append("<img class='pins' src='" + tab.map.pins[j] + "' />")
						}
					}
					$("#ans-map-main-slider .swiper-wrapper").append($el);

					// Create navigation slider
					var $el = $thumbModel.clone();
					$el.find(".title .en").html(tab.tab_title.en);
					$el.find(".title .fr").html(tab.tab_title.fr);
					$el.find(".tab-icon-img").attr("src", tab.tab_icon);
					$el.css("background-color", tab.color);
					$("#ans-map-nav-slider .swiper-wrapper").append($el);

				}, this));

				this.thumbsSwiper = new Swiper('#ans-map-nav-slider', {
					speed: 400,
					spaceBetween: 4,
					slidesPerView: this.data.tabs.length,
					watchOverflow: true,
					width: 1852,
				});

				this.mainSwiper = new Swiper('#ans-map-main-slider', {
					speed: 400,
					// spaceBetween: 100,
					thumbs: {
						swiper: this.thumbsSwiper
					},
					effect: "fade",
					fadeEffect: {
						crossFade: true
					},
					width: 1920,
				});

				this.mainSwiper.on("slideChange", $.proxy(function (e, f, g) {
					if (this.currentScreen == 3) {
						this.initScreenAudio(3);
					}
				}, this))

				// Preload audio
				var allAudioFiles = this.findAllAudioFiles(this.data);
				this.audio.preload(allAudioFiles)

				resolve();

			}, this));
		}

		// To be overriden in child games
		ANSMap.prototype.initGame = function () {

			// Go to first screen
			if (inElectron() || inBrightSign()) {
				this.initScreenSaver();
				this.goToScreen(1);
			} else {
				$("#first-click-interact").one(this.touchEvent, $.proxy(this.initScreenSaver, this));
				this.goToScreen("first-click-interact");
			}

			// this.initScreenSaver();
			// this.goToScreen(1);
			// app.lastClick = 0
		};

		// To be overriden in child games
		ANSMap.prototype.initScreen = function (screenId) {

			// Super constructor
			if (BaseGameLYVLC.prototype.initScreen.call(this, screenId) == false) {
				return false;
			}

			switch (screenId) {
				case 1:
					this.reset();
					break;
				case 2:
					this.instructionsSwiper.slideTo(0, 0);
					this.startInstructionVideo(0);
					break;
				case 3:
					this.stopAllInstructionVideos();
					break;
			}

			this.initScreenAudio(screenId);
		}

		// To be overriden in child games
		ANSMap.prototype.initScreenAudio = function (screenId) {

			switch (screenId) {
				case 1:
					this.playlist.clear();
					// this.playlist.add(this.data.content.initial_screen.audio_repeat, true, 2000);
					this.playlist.add(this.data.content.initial_screen.audio[this.i18n.lang], false);
					this.playlist.play();
					break;
				case 2:
					// Instructions
					var instructionIndex = this.instructionsSwiper.activeIndex + 1;
					this.playlist.clear();
					if (this.data.content["instruction" + instructionIndex].audio) {
						this.playlist.add(this.data.content["instruction" + instructionIndex].audio[this.i18n.lang], false, false, false, true);
					}
					if (this.data.content["instruction" + instructionIndex].audio_repeat) {
						this.playlist.add(this.data.content["instruction" + instructionIndex].audio_repeat[this.i18n.lang], true, 5000);
					}
					this.playlist.play();
					break;
				case 3:
					// Slider
					var slideIndex = this.mainSwiper.activeIndex;
					this.playlist.clear();
					if (this.data.tabs[slideIndex].audio) {
						this.playlist.add(this.data.tabs[slideIndex].audio[this.i18n.lang], false, false, false, true);
					}
					if (this.data.tabs[slideIndex].audio_repeat) {
						this.playlist.add(this.data.tabs[slideIndex].audio_repeat[this.i18n.lang], true, 5000);
					}
					this.playlist.play();
					break;
				case 4:
					// Slider
					break;
			}
		}

		// To be overriden in child games
		ANSMap.prototype.onMessage = function (e) {
			var message = e.message;
			console.log("message received : ", message);

			// Reset still there interval
			this.resetTimer();

			if (this.lockScreen) {
				return;
			}

			if (this.stillThereTimeout != false) {
				this.closeStillThereModal();
				this.initScreenAudio(this.currentScreen);
				return;
			}

			// Global buttons
			switch (this.currentScreen) {
				case 1:
					if (message == this.buttons["english"]) {
						// English button
						this.playlist.clear();
						this.requestedLanguage = "en";
						this.goToScreen(2);
					} else if (message == this.buttons["french"]) {
						// French button
						this.playlist.clear();
						this.requestedLanguage = "fr";
						this.goToScreen(2);
					} else if (message == this.buttons["home"]) {
						// Home button
					}
					break;
				case 3:
					if (message == this.buttons["english"]) {
						// English button
						this.playlist.clear();
						this.i18n.setWithFlip("en");
						this.initScreenAudio(3);
					} else if (message == this.buttons["french"]) {
						// French button
						this.playlist.clear();
						this.i18n.setWithFlip("fr");
						this.initScreenAudio(3);
					} else if (message == this.buttons["home"]) {
						// Home button
						this.playlist.clear();
						this.goToScreen(1);
					}
					break;
				default:
					if (message == this.buttons["english"]) {
						// English button
						this.i18n.setWithFlip("en");
						this.initScreen(this.currentScreen);
					} else if (message == this.buttons["french"]) {
						// French button
						this.i18n.setWithFlip("fr");
						this.initScreen(this.currentScreen);
					} else if (message == this.buttons["home"]) {
						// Home button
						this.playlist.clear();
						this.goToScreen(1);
					}
					break;
			}


			// Left, right and select butttons
			switch (this.currentScreen) {
				case 1:
					break;
				case 2:
					if (message == this.buttons["select"] || message == this.buttons["right"]) {
						// SELECT OR NEXT
						if (this.instructionsSwiper.activeIndex >= (this.instructionsSwiper.slides.length - 1)) {
							this.playlist.clear();
							this.goToScreen(3);
						} else {
							this.instructionsSwiper.slideNext();
							this.initScreenAudio(2);
						}
					} else if (message == this.buttons["left"]) {
						// LEFT
						this.instructionsSwiper.slidePrev();
						this.initScreenAudio(2);
					}
					break;
				case 3:
					if (message == this.buttons["left"]) {
						// LEFT
						this.mainSwiper.slidePrev();
					} else if (message == this.buttons["select"] || message == this.buttons["right"]) {
						// SELECT OR NEXT
						this.mainSwiper.slideNext();
					}
					break;
			}
		}

		ANSMap.prototype.startInstructionVideo = function (slideIndex) {
			var slides = $(this.instructionsSwiper.el).find(".swiper-slide");
			slides.each(function (i, n) {
				$(n).find("video").each(function (i2, n2) {
					if (i == slideIndex) {
						n2.play();
					} else {
						n2.currentTime = 0;
						n2.pause();
					}
				});
			});
		}

		ANSMap.prototype.stopInstructionVideos = function () {
			var slides = $(this.instructionsSwiper.el).find(".swiper-slide");
			slides.each(function (i, n) {
				$(n).find("video").each(function (i2, n2) {
					n2.pause();
				});
			});
		}

		ANSMap.prototype.stopAllInstructionVideos = function () {
			var videos = $(this.instructionsSwiper.el).find("video");
			videos.each(function (i, n) {
				n.pause();
			});
		}

		ANSMap.prototype.goToScreenSaver = function () {

			// Super constructor
			if (BaseGameLYVLC.prototype.goToScreenSaver.call(this) == false) {
				return false;
			}
		}

		ANSMap.prototype.reset = function (screenId) {

			// Super
			if (BaseGameLYVLC.prototype.reset.call(this, screenId) == false) {
				return false;
			}

			// Reset instruction slider
			this.instructionsSwiper.slideTo(0);
			this.stopAllInstructionVideos();

			// Reset sliders
			this.thumbsSwiper.slideTo(0);
			this.mainSwiper.slideTo(0);

			if (this.redirectTimeout != false) {
				clearTimeout(this.redirectTimeout);
				this.redirectTimeout = false;
			}

		}

		// Expose ANSMap
		window.ANSMap = ANSMap;
	}
)
(jQuery, Promise);

